/* No Nicotine */
export const noNicotineTable = {
  F: {
    '25-29': { '50000': 4, '100000': 7, '150000': 11, '200000': 14 },
    '30-34': { '50000': 5, '100000': 9, '150000': 14, '200000': 18 },
    '35-39': { '50000': 6, '100000': 11, '150000': 16, '200000': 22 },
    '40-44': { '50000': 7, '100000': 13, '150000': 19, '200000': 25 },
    '45-49': { '50000': 10, '100000': 18, '150000': 27, '200000': 36 },
    '50-54': { '50000': 14, '100000': 26, '150000': 38, '200000': 50 },
    '55-59': { '50000': 18, '100000': 33, '150000': 49, '200000': 65 },
    '60-64': { '50000': 29, '100000': 53, '150000': 78, '200000': 104 },
    '65-69': { '50000': 69, '100000': 127, '150000': 186, '200000': 248 },
    '70-74': { '50000': 109, '100000': 201, '150000': 294, '200000': 392 },
  },
  M: {
    '25-29': { '50000': 5, '100000': 9, '150000': 14, '200000': 18 },
    '30-34': { '50000': 6, '100000': 11, '150000': 16, '200000': 22 },
    '35-39': { '50000': 7, '100000': 13, '150000': 19, '200000': 25 },
    '40-44': { '50000': 8, '100000': 15, '150000': 22, '200000': 29 },
    '45-49': { '50000': 11, '100000': 20, '150000': 30, '200000': 40 },
    '50-54': { '50000': 15, '100000': 28, '150000': 41, '200000': 54 },
    '55-59': { '50000': 19, '100000': 35, '150000': 51, '200000': 68 },
    '60-64': { '50000': 32, '100000': 59, '150000': 86, '200000': 115 },
    '65-69': { '50000': 99, '100000': 182, '150000': 267, '200000': 356 },
    '70-74': { '50000': 169, '100000': 311, '150000': 465, '200000': 608 },
  },
};

/* With Nicotine */
export const nicotineTable = {
  F: {
    '25-29': { '50000': 5, '100000': 9, '150000': 14, '200000': 18 },
    '30-34': { '50000': 8, '100000': 15, '150000': 22, '200000': 29 },
    '35-39': { '50000': 11, '100000': 20, '150000': 30, '200000': 40 },
    '40-44': { '50000': 14, '100000': 26, '150000': 38, '200000': 50 },
    '45-49': { '50000': 19, '100000': 35, '150000': 51, '200000': 68 },
    '50-54': { '50000': 29, '100000': 53, '150000': 78, '200000': 104 },
    '55-59': {
      '50000': 45,
      '100000': 83,
      '150000': 122,
      '200000': 162,
    },
    '60-64': {
      '50000': 79,
      '100000': 145,
      '150000': 213,
      '200000': 284,
    },
    '65-69': {
      '50000': 129,
      '100000': 237,
      '150000': 348,
      '200000': 464,
    },
    '70-74': {
      '50000': 219,
      '100000': 403,
      '150000': 591,
      '200000': 788,
    },
  },
  M: {
    '25-29': { '50000': 6, '100000': 11, '150000': 16, '200000': 22 },
    '30-34': { '50000': 9, '100000': 17, '150000': 24, '200000': 32 },
    '35-39': { '50000': 12, '100000': 22, '150000': 32, '200000': 43 },
    '40-44': { '50000': 16, '100000': 29, '150000': 43, '200000': 58 },
    '45-49': { '50000': 22, '100000': 40, '150000': 59, '200000': 79 },
    '50-54': {
      '50000': 39,
      '100000': 72,
      '150000': 105,
      '200000': 140,
    },
    '55-59': { '50000': 54, '100000': 99, '150000': 146, '200000': 194 },
    '60-64': {
      '50000': 89,
      '100000': 164,
      '150000': 240,
      '200000': 320,
    },
    '65-69': {
      '50000': 249,
      '100000': 458,
      '150000': 672,
      '200000': 896,
    },
    '70-74': {
      '50000': 349,
      '100000': 642,
      '150000': 942,
      '200000': 1256,
    },
  },
};
